import { Box } from "@mui/material";
import { MineBtn } from "../components/buttons/MineBtn";

export const SecWelcome = () => {
  return (
    <Box
      sx={{
        height: {
          xs: "calc(100vh - 5vh - 16px - 32px)",
          md: "calc(100vh - 5vh - 50px - 32px)",
        },
        with: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        color: "var(--c-text-color)",
        overflow: "hidden",
      }}
    >
    
      <Box
        sx={{
          mt: "90px",
          borderRadius: "50%",
          border: "5px solid var(--c-bg-content-color)",
          boxShadow: "var(--c-box-shadow-btn)",
          transition: "all 0.5s ease-in-out",
          "&:hover": {
            backgroundColor: "var(--c-main-color-hover)",
            boxShadow: "var(--c-box-shadow-btn)",
          },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            height: {
              xs: "30vh",
            },
            width: {
              xs: "30vh",
            },
          }}
        >
          <Box
            component="img"
            sx={{
              zIndex: 5,
              height: {
                xs: "30vh",
              },
              width: {
                xs: "30vh",
              },
              borderRadius: "50%",
              objectFit: "cover",
            }}
            alt="The house from the offer."
            src="/img/360_F.webp"
          />
        </Box>
      </Box>
      <Box
        sx={{
          mt: "20px",
          fontSize: {
            xs: "1.2rem",
            sm: "1.8rem",
            md: "2rem",
          },
        }}
      >
        Hey
      </Box>
      <Box
        sx={{
          fontWeight: 800,
          fontSize: {
            xs: "1.8rem",
            sm: "3rem",
            md: "4rem",
          },
        }}
      >
        I’m Serhii Petrenko
      </Box>
      <Box
        sx={{
          fontWeight: 500,
          fontSize: {
            xs: "1.5rem",
            sm: "1.8rem",
            md: "2rem",
          },
          display: "flex",
          borderRight: "2px solid",
          animation: "switch-animation 1s infinite linear",
        }}
      >
        Front-end{" "}
        <Box sx={{ ml: "10px", mr: "10px", color: "#D32D20" }}>developer</Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          textAlign: "center",
          width: {
            xs: "85%",
            sm: "75%",
            md: "65%",
          },
          mt: "10px",
          fontWeight: 300,
          fontSize: {
            xs: "0.8rem",
            sm: "0.9rem",
            md: "1rem",
          },
        }}
      >
        With strong motivation for self-education and a results-oriented
        mindset, I am passionate about coding and always seeking new
        opportunities for growth. I am inspired to apply my skills in real
        projects and contribute to the industry. Open to challenges, I strive to
        stay at the forefront of technology.
      </Box>
      <Box
        sx={{
          marginY: "20px",
          "& .mine-btn": {
            fontSize: {
              xs: "0.6rem",
              sm: "0.7rem",
              md: "0.8rem",
            },
          },
        }}
      >
        <MineBtn
          sx={{ height: "40px" }}
          text={"Contact me"}
          link={"/#contact-me"}
        />
      </Box>
    </Box>
  ); /*  */
};
